<template>
  <div class="km__modules__text--list">
    <button
        @click="$emit('endTextEditing')"
        class="km__button--back" type="button" name="back">
      back
    </button>
    <button
        @click="$emit('endTextEditing')"
        class="km__button--close" type="button" name="close">
      close
    </button>
    <ul class="km__list--modules"
        v-if="textObjects.length > 0">
      <li
          v-for="(item) in textObjects"
          :key="item.id"
          class="km__list__element--modules"
      >
        <div class="text__element">
          <span class="text__element__display">
            {{ item.value }}
          </span>
          <span
              @click="getTextElem(item.id)"
              class="km__button--text edit">
            Bearbeiten
          </span>
          <span
              @click="$emit('deleteTextElem', item.id)"
              class="km__button--text delete">
            löschen
          </span>
        </div>
      </li>
    </ul>
    <div v-else>
      Keine Textelemente vorhanden!
    </div>
  </div>
</template>

<script lang="ts" setup>

import {EventVerteiler} from "@k/global/eventVerteiler";
import {computed, ComputedRef, watch} from "vue";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {setWatchToAnimateOnStatechange} from "@km/js/animater";
import {SelectableObject, TextObject} from "@k/js/selectableObjects";
import {filterOutClones} from "@km/js/SelObCloneFilter";
import {useModuleTextOpenStatusStore} from "@km/store/frontendstate/useModuleTextOpenState";

const props = defineProps(
    {
      textList: Array
    }
);
const emit = defineEmits(["closeModule", "endTextEditing", "deleteTextElem"]);


const openStatusStore = useModuleTextOpenStatusStore();
setWatchToAnimateOnStatechange(
    AnimationWaitingForTargetFactory.getUpDownAnimation('.km__modules__text--list'),
    new KeyFrameTargetValues(0, 200),
    () => openStatusStore.gettextlistState
);
watch(() => props.textList, textList => {
  if (textList!.length === 0) {
    emit("closeModule")
  }
})


const getTextElem = (id: string) => EventVerteiler.broadcast("selObSelectedFromRahmen", id);
const textObjects = computed(() => filterOutClones(props.textList as SelectableObject[])) as ComputedRef<TextObject[]>;


</script>

<style lang="scss" scoped>
@use "../../scss/settings/config" as config;

/* ***********************************
*	TEXT LIST
*   - Text Element
*   - Column 4 Text Elements
*   - Slider Text list
* ********************************** */

/* ***********************************
*	TEXT LIST - Text Element
* ********************************** */
.text__element {
  height: 32px;
  border-top: 1px solid config.$color-black;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .text__element__display {
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: calc(100% - 60px);
  }
}

/* ***********************************
*	TEXT LIST - Column 4 Text Elements
* ********************************** */
.km__modules__text--list {
  .km__list__element--modules {
    display: flex;
    flex-direction: column;
    width: 150px;

    &:nth-child(4n),
    &:last-child {
      .text__element {
        border-bottom: 1px solid config.$color-black;
      }
    }
  }
}

/* ***********************************
*	TEXT LIST - Slider Text list
* ********************************** */
.km__modules__text--list {
  position: fixed;
  height: 200px;
  width: 100%;
  left: 0;
  bottom: config.$cta-height;
  z-index: 99;
  background: config.$color-white;
  padding: 50px 10px 10px 10px;
  transform: translate(0px, 200px);
  overflow-y: hidden;

  .km__list--modules {
    position: relative;
    padding-bottom: 170px;
    overflow-x: scroll;
    display: grid;
    grid-template-rows: repeat(4, auto);
    grid-gap: 0 15px;
    grid-auto-flow: column;
  }
}
</style>
